import BannerCustomerPreview from 'components/CustomerItemPreview/BannerCustomerPreview';
import LookCustomerPreview from 'components/CustomerItemPreview/LookCustomerPreview';
import ProductCustomerPreview from 'components/CustomerItemPreview/ProductCustomerPreview';
import PropTypes from 'prop-types';
import React from 'react';

const PREVIEW_COMPONENTS = {
  banner: BannerCustomerPreview,
  look: LookCustomerPreview,
  product: ProductCustomerPreview,
};

const MediaCropPreview = ({ cropMediaType, previewData, previewImage }) => {
  if (!previewImage) return null;

  const PreviewComponent = PREVIEW_COMPONENTS[cropMediaType];
  if (!PreviewComponent) return null;

  return (
    <PreviewComponent
      media={previewImage}
      name={previewData?.name}
      description={previewData?.description}
      price={previewData?.price}
      currency={previewData?.currency}
      size={previewData?.size}
      color={previewData?.color}
      products={previewData?.products}
      originImage={previewData?.originImage}
    />
  );
};

MediaCropPreview.propTypes = {
  cropMediaType: PropTypes.oneOf(['banner', 'look', 'product']).isRequired,
  previewData: PropTypes.shape({
    name: PropTypes.string,
    description: PropTypes.string,
    price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    currency: PropTypes.string,
    size: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    color: PropTypes.object,
    products: PropTypes.arrayOf(PropTypes.object),
    originImage: PropTypes.string,
  }),
  previewImage: PropTypes.string,
};

export default MediaCropPreview;
